/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExternalCase,
    ExternalCaseFromJSON,
    ExternalCaseFromJSONTyped,
    ExternalCaseToJSON,
    ExternalPartners,
    ExternalPartnersFromJSON,
    ExternalPartnersFromJSONTyped,
    ExternalPartnersToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExternalCaseIEnumerableExternalPartnerResponse
 */
export interface ExternalCaseIEnumerableExternalPartnerResponse {
    /**
     * 
     * @type {ExternalPartners}
     * @memberof ExternalCaseIEnumerableExternalPartnerResponse
     */
    partner?: ExternalPartners;
    /**
     * 
     * @type {number}
     * @memberof ExternalCaseIEnumerableExternalPartnerResponse
     */
    responseCode?: number;
    /**
     * 
     * @type {Array<ExternalCase>}
     * @memberof ExternalCaseIEnumerableExternalPartnerResponse
     */
    data?: Array<ExternalCase> | null;
}

export function ExternalCaseIEnumerableExternalPartnerResponseFromJSON(json: any): ExternalCaseIEnumerableExternalPartnerResponse {
    return ExternalCaseIEnumerableExternalPartnerResponseFromJSONTyped(json, false);
}

export function ExternalCaseIEnumerableExternalPartnerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalCaseIEnumerableExternalPartnerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partner': !exists(json, 'partner') ? undefined : ExternalPartnersFromJSON(json['partner']),
        'responseCode': !exists(json, 'responseCode') ? undefined : json['responseCode'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(ExternalCaseFromJSON)),
    };
}

export function ExternalCaseIEnumerableExternalPartnerResponseToJSON(value?: ExternalCaseIEnumerableExternalPartnerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partner': ExternalPartnersToJSON(value.partner),
        'responseCode': value.responseCode,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(ExternalCaseToJSON)),
    };
}


